import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BrandMark from "../components/BrandMark";
import { useAuth } from "../contexts/AuthContext";

// LT-Publish-B1: dev-bypass panel has been removed from the login UI.
// Signing in via Google (Emergent-managed OAuth) is the only supported
// entry point from this page. The dev-login API endpoint may still be
// reachable in the preview environment (see DEV_LOGIN_ENABLED in
// backend/.env), but it has no visible affordance and must be disabled in
// production per the publish checklist in plan.md.

export default function Login() {
  const { user, loading, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && user) {
      const dest = location.state?.from?.pathname || "/dashboard";
      navigate(dest, { replace: true });
    }
  }, [user, loading, navigate, location.state]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg">
      <div
        className="w-full max-w-[420px] bg-surface border border-line rounded-lg shadow-card px-7 py-8"
      >
        <div className="flex items-center justify-center mb-7">
          <BrandMark brand="Lux Construction" />
        </div>

        <h1
          className="font-display text-ink text-center"
          style={{ fontSize: 22, fontWeight: 600, letterSpacing: "-0.01em" }}
        >
          Welcome back
        </h1>
        <p className="text-ink-3 text-center mt-1" style={{ fontSize: 12.5 }}>
          Sign in to LuxTender
        </p>

        <div className="mt-7">
          <button
            onClick={loginWithGoogle}
            className="w-full h-10 rounded-md bg-ink text-bg flex items-center justify-center gap-2.5 hover:bg-ink-2 transition-colors"
            style={{ fontSize: 13, fontWeight: 500 }}
            data-testid="login-google-btn"
          >
            <svg width="15" height="15" viewBox="0 0 24 24">
              <path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#fff" opacity="0.85" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
              <path fill="#fff" opacity="0.7" d="M5.84 14.09A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.43.34-2.09V7.07H2.18A11 11 0 0 0 1 12c0 1.78.42 3.46 1.18 4.93l3.66-2.84z"/>
              <path fill="#fff" opacity="0.55" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
            </svg>
            Sign in with Google
          </button>
          <p className="text-ink-4 text-center mt-2" style={{ fontSize: 11 }}>
            Single sign-on via Emergent managed Google OAuth
          </p>
        </div>
      </div>
    </div>
  );
}
